//@ts-nocheck
import Router, { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/jha-tab/jha-tab";
import "@banno/jha-wc/src/jha-tab-item/jha-tab-item";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "./WorkflowGeneralInfoView";
import "./NotificationView";
import "./WorkflowStepsView";
import "./SchedulerView";
import {
    WorkflowType,
    FileInfoType,
    DEFAULT_WORKFLOW_TYPE_ODI,
} from "../../types/Workflow/WorkflowDataType";
import { Apis } from "../../utils/api-constants";
import { getWorkflowSaveErrorMessage } from "../../utils/getErrorMessage";
import { GlobalConstants } from "../../utils/constants";
import {
    deleteRequest,
    fixedEncodeURIComponent,
    getRequest,
    postRequest,
    putRequest,
} from "../../utils/jha-fetch";
import { routerConfig } from "../../routers";
import { AppRouters } from "../../utils/app-router";
import { isGeneralInfoTabComplete, syncGeneralInfoValid } from "../../utils/workflow-general-info-valid";
import { workflowSaveInvalidBlankMessage } from "../../utils/workflow-save-validation";
import {
    decryptValue,
    stringComparison,
    stringComparisonCase,
    showToastMessage,
    getCurrentDateTimeInTimeZone,
    getTimeZoneIdentifier,
} from "../../utils/app-utils";
import { formatWorkflowSchedulerNow } from "../../utils/datetime-display";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import {
    afterGeneralInfoLoad,
    applyWorkflowCancelBaselineDefaults,
    captureWorkflowCancelBaseline,
    isWorkflowCancelDirty,
    resolveGeneralInfoAutoFill,
} from "../../utils/workflow-cancel-dirty";
import Cookies from "js-cookie";
import {
    applyFileLocationAuthTypeIfSftpFtps,
    applyPushSftpAuthTypeToCredentialSourceFileInfo,
    cloneSecretValueOmitAuthType,
    syncStepAuthTypesFromBothFileInfos,
} from "../../utils/workflow-file-location-secret";
import {
    applyInstitutionUuidOutbound,
    readInstitutionUuidFromStep,
} from "../../utils/workflow-institution-step";
import {
    extractSourceLocationSuffix,
    firstHex32WorkflowId,
    resolvePullSourceLocationPathForSave,
    resolvePushSourceLocationPathForSave,
} from "../../utils/workflow-source-location-path";
import { abortWorkflowLoad } from "../../utils/workflow-not-found-message";

@customElement("edit-workflow-tab-view")
export class EditWorkflowTabView extends routingMixin(LitElement) {
    constructor() {
        super();
    }

    @property() pageTitle = "Edit";
    @property() activeTab = "page1";
    @property({ reflect: true, attribute: "workflow-id" })
    workflowId = "";

    @property({ type: Object })
    workflowData = {
        isEdit: false,
        isSourceLocationValid: true,
        isWorkflowNameValid: true,
    };
    @property({ type: Object })
    filepattern = {
        TriggerFilePattern: [],
        DataFilePattern: [],
        isEdit: false,
        valid: false,
    };
    @property({ type: Object })
    schedulerData = { valid: true, isEdit: true };
    @property()
    oldSchedulerData = {};
    @property()
    sourceFolder = "";
    @property()
    loadedSourceLocationSuffix = "";
    @property({ type: Array })
    notification = [{ number: Number, added: Boolean }];
    @property()
    steps = {};
    @property()
    toUpdate: "update";
    @property({ type: Boolean })
    workFlowDisable = false;
    @property({ type: Object })
    workflow: WorkflowType = {
        WorkflowName: "",
        sourceLocationPath: "",
        BusinessUnitParticipant: "",
        DeleteFiles: "",
        DataFilePattern: [],
        TriggerFilePattern: [],
        Notification: [],
        status: "",
        Scheduler: {
            SchedulerName: "",
            Description: "",
            Expression: "",
            TimeZone: "",
            StartDate: "",
            StartTime: "",
            EndDate: "",
            EndTime: "",
        },
        workflowType: "",
        workflowSteps: [],
        TransferType: "",
    };
    @property({ type: Object })
    sourceFileInfo: FileInfoType = {};
    @property()
    workflowResponse: any;
    @property({ type: Boolean })
    isReadOnlyUser = /readonly/i.test(
        decryptValue(Cookies.get("userRole") || "")
    );
    /** ACME-1050: baseline after hydrate — see `workflow-cancel-dirty.ts` (do not latch dirty from tab events). */
    private _cancelBaseline: string | null = null;
    private _giDefaultsFolded = false;
    @property({ type: Boolean })
    isFilePatternValid =
        this.filepattern.DataFilePattern.length <= 0 &&
        this.filepattern.TriggerFilePattern.length <= 0;
    @property({ type: Boolean })
    isSchedulerValid = this.schedulerData.valid;
    @property({ type: Object })
    notificationData = {
        number: 1,
        messageType: "",
        notificationType: "",
        to: "",
        subject: "",
        template: "",
        added: false,
    };

    static get is() {
        return "edit-workflow-tab-view";
    }

    static readonly styles = css`
    #editWorkflowTab {
      padding: 24px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    jha-card {
      padding: 24px;
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;
      overflow: hidden;
    }

    #tabContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: scroll;
    }

    #backBtn {
      cursor: pointer;
      margin-right: 10px;
    }

    jha-tab-item > [icon] {
      margin-right: 8px;
      vertical-align: middle;
    }

    jha-icon-circle-checkmark-filled {
      fill: var(--jha-color-success);
    }

    jha-icon-warning-filled {
      fill: var(--jha-color-warning);
    }
  `;

    onSaveWorkflowCustomEvent(e) {
        this.workflowData = e.detail;
    }

    unsavednotificationChanges(e) {
        this.notificationData = e.detail;
    }

    onSaveNotificationCustomEvent(e) {
        this.notification = e.detail;
    }

    onSaveStepsCustomEvent(e) {
        this.steps = e.detail.workflowStepsData;
        this.workflowData.DeleteFiles = e.detail.deleteFiles;
    }

    onSaveSchedulerEvent(e) {
        this.schedulerData = e.detail;
        this.isSchedulerValid = this.schedulerData.valid;
    }

    async onSaveWorkflowClick() {
        this.apiLoading = true;
        this.toUpdate = this.toUpdate == "" ? "update" : "";
        syncGeneralInfoValid(this.workflowData);
        let currentDateTime = null;
        let scheduledDateTime = null;
        if (
            this.schedulerData.StartDate &&
            this.schedulerData.StartHour &&
            this.schedulerData.StartMinute
        ) {
            scheduledDateTime = new Date(
                `${this.schedulerData.StartDate}T${this.schedulerData.StartHour}:${this.schedulerData.StartMinute}`
            );
            currentDateTime = getCurrentDateTimeInTimeZone(
                getTimeZoneIdentifier(this.schedulerData.TimeZone)
            );
            currentDateTime.setSeconds(0, 0);
        }
        if (
            stringComparison(this.workflowData.TransferType, "PUSH") &&
            (!this.workflowData.valid ||
                this.filepattern.DataFilePattern.length <= 0 ||
                this.filepattern.TriggerFilePattern.length <= 0)
        ) {
            this.apiLoading = false;
            this.toUpdate = this.toUpdate == "" ? "update" : "";
            this.requestUpdate();
            showToastMessage(
                workflowSaveInvalidBlankMessage({
                    workflowData: this.workflowData,
                    filepattern: this.filepattern,
                    includeScheduler: false,
                }),
                "danger",
            );
        } else if (
            stringComparison(this.workflowData.TransferType, "PULL") &&
            (!this.workflowData.valid ||
                this.filepattern.DataFilePattern.length <= 0 ||
                this.filepattern.TriggerFilePattern.length <= 0 ||
                !this.schedulerData.valid)
        ) {
            this.apiLoading = false;
            this.toUpdate = this.toUpdate == "" ? "update" : "";
            this.requestUpdate();
            showToastMessage(
                workflowSaveInvalidBlankMessage({
                    workflowData: this.workflowData,
                    filepattern: this.filepattern,
                    schedulerData: this.schedulerData,
                    includeScheduler: true,
                }),
                "danger",
            );
        } else if (
            (this.oldSchedulerData.TimeZone !== this.oldSchedulerData.TimeZone ||
                this.oldSchedulerData.StartDate !== this.schedulerData.StartDate ||
                this.oldSchedulerData.StartHour !== this.schedulerData.StartHour ||
                this.oldSchedulerData.StartMinute !== this.schedulerData.StartMinute) &&
            this.schedulerData.StartDate != undefined &&
            scheduledDateTime < currentDateTime
        ) {
            const formatedDateTime = formatWorkflowSchedulerNow(this.schedulerData.TimeZone);
            this.apiLoading = false;
            showToastMessage(
                `Scheduler start datetime cannot be less than current datetime ${formatedDateTime}`,
                "danger"
            );
        } else {
            //steps
            if (this.steps.length > 0) {
                let workflowSteps = {
                    FunctionName: "",
                    StepName: "",
                    DeleteSourceFile: false,
                    FileMovePattern: [],
                    DestinationFileInfo: {
                        Name: "",
                        Path: "",
                        LocationType: "",
                        StorageType: "",
                        FileRename: {},
                        BucketRename: "",
                        SecretName: "",
                        SecretValue: {},
                    },
                    SourceFileInfo: {
                        Name: "",
                        Path: "",
                        LocationType: "",
                        StorageType: "",
                        FileRename: {},
                        BucketRename: "",
                        SecretName: "",
                        SecretValue: {},
                    },
                    StepIndex: 0,
                };

                this.workflow.workflowSteps = [];
                if (stringComparison(this.workflowData.TransferType, "PUSH")) {
                    for (let i = 0; i < this.steps.length; i++) {
                        this.workflow.workflowSteps.push(
                            JSON.parse(JSON.stringify(workflowSteps))
                        );
                        this.workflow.workflowSteps[i].StepName = this.steps[i].stepName;
                        this.workflow.workflowSteps[i].FunctionName =
                            this.steps[i].functionName;
                        this.workflow.workflowSteps[i].DeleteSourceFile = stringComparison(
                            this.steps[i].deleteSourceFile,
                            "true"
                        )
                            ? true
                            : false;
                        this.workflow.workflowSteps[i].StepIndex =
                            this.steps[i].stepIndex - 1;
                        this.workflow.workflowSteps[i].FileMovePattern =
                            this.steps[i].FileMovePattern;
                        applyInstitutionUuidOutbound(
                            this.workflow.workflowSteps[i],
                            this.steps[i].institutionUuid
                        );
                        if (
                            stringComparison(
                                this.workflow.workflowSteps[i].FunctionName,
                                "filedownload"
                            ) ||
                            stringComparison(
                                this.workflow.workflowSteps[i].FunctionName.toLowerCase(),
                                "filedelete"
                            )
                        ) {
                            this.workflow.workflowSteps[i].SourceFileInfo.Name =
                                this.steps[i].name;
                            if (
                                this.steps[i].path != undefined ||
                                this.steps[i].path != null
                            ) {
                                this.workflow.workflowSteps[i].SourceFileInfo.Path =
                                    this.steps[i].path;
                            }
                            this.sourceFolder = this.steps[i].name;
                            this.workflow.workflowSteps[i].SourceFileInfo.LocationType =
                                this.steps[i].locationType;
                            this.workflow.workflowSteps[i].SourceFileInfo.StorageType =
                                this.steps[i].storageType;
                            this.workflow.workflowSteps[i].SourceFileInfo.FileRename =
                                this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].SourceFileInfo.BucketRename =
                                this.steps[i].bucketRename;

                            if (
                                this.steps[i].storageType == "azure" ||
                                this.steps[i].storageType == "amazons3remote"
                            ) {
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName =
                                    this.steps[i].secretName;
                            } else {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretName =
                                    this.steps[i].secretName;
                            }
                            if (
                                this.steps[i].secretValue != undefined &&
                                this.steps[i].secretValue.hideValue == undefined
                            ) {
                                if (
                                    this.steps[i].storageType == "azure" ||
                                    this.steps[i].storageType == "amazons3remote"
                                ) {
                                    this.workflow.workflowSteps[
                                        i
                                    ].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                        this.steps[i].secretValue
                                    );
                                } else {
                                    this.workflow.workflowSteps[i].SourceFileInfo.SecretValue =
                                        cloneSecretValueOmitAuthType(this.steps[i].secretValue);
                                }
                            }
                            applyFileLocationAuthTypeIfSftpFtps(
                                this.workflow.workflowSteps[i].SourceFileInfo,
                                this.steps[i],
                                "source"
                            );
                            applyFileLocationAuthTypeIfSftpFtps(
                                this.workflow.workflowSteps[i].DestinationFileInfo,
                                this.steps[i],
                                "destination"
                            );
                        } else {
                            this.workflow.workflowSteps[i].DestinationFileInfo.Name =
                                this.steps[i].name;
                            if (
                                this.steps[i].path != undefined ||
                                this.steps[i].path != null
                            ) {
                                this.workflow.workflowSteps[i].DestinationFileInfo.Path =
                                    this.steps[i].path;
                            }
                            this.workflow.workflowSteps[i].DestinationFileInfo.LocationType =
                                this.steps[i].locationType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.StorageType =
                                this.steps[i].storageType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.FileRename =
                                this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].DestinationFileInfo.BucketRename =
                                this.steps[i].bucketRename;

                            if (
                                this.steps[i].storageType == "azure" ||
                                this.steps[i].storageType == "amazons3remote"
                            ) {
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName =
                                    this.steps[i].secretName;
                            } else {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretName =
                                    this.steps[i].secretName;
                            }
                            if (
                                this.steps[i].secretValue != undefined &&
                                this.steps[i].secretValue.hideValue == undefined
                            ) {
                                if (
                                    this.steps[i].storageType == "azure" ||
                                    this.steps[i].storageType == "amazons3remote"
                                ) {
                                    this.workflow.workflowSteps[
                                        i
                                    ].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                        this.steps[i].secretValue
                                    );
                                } else {
                                    this.workflow.workflowSteps[i].SourceFileInfo.SecretValue =
                                        cloneSecretValueOmitAuthType(this.steps[i].secretValue);
                                }
                            }
                            applyFileLocationAuthTypeIfSftpFtps(
                                this.workflow.workflowSteps[i].SourceFileInfo,
                                this.steps[i],
                                "source"
                            );
                            applyFileLocationAuthTypeIfSftpFtps(
                                this.workflow.workflowSteps[i].DestinationFileInfo,
                                this.steps[i],
                                "destination"
                            );
                            applyPushSftpAuthTypeToCredentialSourceFileInfo(
                                this.workflow.workflowSteps[i].SourceFileInfo,
                                this.steps[i],
                                this.steps[i].storageType
                            );
                        }
                    }
                } else if (stringComparison(this.workflowData.TransferType, "PULL")) {
                    for (let i = 0; i < this.steps.length; i++) {
                        this.workflow.workflowSteps.push(
                            JSON.parse(JSON.stringify(workflowSteps))
                        );
                        this.workflow.workflowSteps[i].StepName = this.steps[i].stepName;
                        this.workflow.workflowSteps[i].FunctionName =
                            this.steps[i].functionName;
                        this.workflow.workflowSteps[i].DeleteSourceFile = stringComparison(
                            this.steps[i].deleteSourceFile,
                            "true"
                        )
                            ? true
                            : false;
                        this.workflow.workflowSteps[i].StepIndex = this.steps[i].stepIndex;
                        this.workflow.workflowSteps[i].FileMovePattern =
                            this.steps[i].FileMovePattern;
                        applyInstitutionUuidOutbound(
                            this.workflow.workflowSteps[i],
                            this.steps[i].institutionUuid
                        );
                        if (
                            stringComparison(
                                this.workflow.workflowSteps[i].FunctionName,
                                "filedownload"
                            ) ||
                            stringComparison(
                                this.workflow.workflowSteps[i].FunctionName.toLowerCase(),
                                "filedelete"
                            )
                        ) {
                            this.workflow.workflowSteps[i].SourceFileInfo.Name =
                                this.steps[i].name;
                            this.workflow.workflowSteps[i].SourceFileInfo.Path =
                                this.steps[i].path;
                            this.sourceFolder = this.steps[i].name;
                            this.workflow.workflowSteps[i].SourceFileInfo.LocationType =
                                this.steps[i].locationType;
                            this.workflow.workflowSteps[i].SourceFileInfo.StorageType =
                                this.steps[i].storageType;
                            this.workflow.workflowSteps[i].SourceFileInfo.FileRename =
                                this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].SourceFileInfo.BucketRename =
                                this.steps[i].bucketRename;


                            this.workflow.workflowSteps[i].SourceFileInfo.SecretName =
                                this.steps[i].secretName;
                            if (
                                this.steps[i].secretValue != undefined &&
                                this.steps[i].secretValue.hideValue == undefined
                            ) {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue =
                                    cloneSecretValueOmitAuthType(this.steps[i].secretValue);
                            }
                            applyFileLocationAuthTypeIfSftpFtps(
                                this.workflow.workflowSteps[i].SourceFileInfo,
                                this.steps[i],
                                "source"
                            );
                            applyFileLocationAuthTypeIfSftpFtps(
                                this.workflow.workflowSteps[i].DestinationFileInfo,
                                this.steps[i],
                                "destination"
                            );
                        } else {
                            this.workflow.workflowSteps[i].DestinationFileInfo.Name =
                                this.steps[i].name;
                            if (
                                this.steps[i].path != undefined ||
                                this.steps[i].path != null
                            ) {
                                this.workflow.workflowSteps[i].DestinationFileInfo.Path =
                                    this.steps[i].path;
                            }
                            this.workflow.workflowSteps[i].DestinationFileInfo.LocationType =
                                this.steps[i].locationType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.StorageType =
                                this.steps[i].storageType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.FileRename =
                                this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].DestinationFileInfo.BucketRename =
                                this.steps[i].bucketRename;

                            if (
                                this.steps[i].storageType == "azure" ||
                                this.steps[i].storageType == "amazons3remote"
                            ) {
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName =
                                    this.steps[i].secretName;
                            } else {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretName =
                                    this.steps[i].secretName;
                            }
                            if (
                                this.steps[i].secretValue != undefined &&
                                this.steps[i].secretValue.hideValue == undefined
                            ) {
                                if (
                                    this.steps[i].storageType == "azure" ||
                                    this.steps[i].storageType == "amazons3remote"
                                ) {
                                    this.workflow.workflowSteps[
                                        i
                                    ].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                        this.steps[i].secretValue
                                    );
                                } else {
                                    this.workflow.workflowSteps[i].SourceFileInfo.SecretValue =
                                        cloneSecretValueOmitAuthType(this.steps[i].secretValue);
                                }
                            }
                            applyFileLocationAuthTypeIfSftpFtps(
                                this.workflow.workflowSteps[i].SourceFileInfo,
                                this.steps[i],
                                "source"
                            );
                            applyFileLocationAuthTypeIfSftpFtps(
                                this.workflow.workflowSteps[i].DestinationFileInfo,
                                this.steps[i],
                                "destination"
                            );
                            applyPushSftpAuthTypeToCredentialSourceFileInfo(
                                this.workflow.workflowSteps[i].SourceFileInfo,
                                this.steps[i],
                                this.steps[i].storageType
                            );
                        }
                    }
                }
            }
            //notification
            if (this.notification.length > 0) {
                let notifications = {
                    messageType: "",
                    notificationType: "",
                    to: "",
                    subject: "",
                    template: "",
                };
                this.workflow.Notification = [];
                for (let i = 0; i < this.notification.length; i++) {
                    this.workflow.Notification.push(
                        JSON.parse(JSON.stringify(notifications))
                    );
                    this.workflow.Notification[i].to = this.notification[i].to;
                    this.workflow.Notification[i].subject = this.notification[i].subject;
                    this.workflow.Notification[i].messageType =
                        this.notification[i].messageType;
                    this.workflow.Notification[i].notificationType =
                        this.notification[i].notificationType;
                    this.workflow.Notification[i].template =
                        this.notification[i].template;
                }
            } else {
                this.workflow.Notification = null;
            }
            if (this.schedulerData != undefined) {
                this.workflow.Scheduler.Description = this.schedulerData.Description;
                this.workflow.Scheduler.Expression = this.schedulerData.Expression;
                this.workflow.Scheduler.StartDate = this.schedulerData.StartDate;
                if (this.schedulerData.StartHour != undefined) {
                    this.workflow.Scheduler.StartTime = `${this.schedulerData.StartHour}:${this.schedulerData.StartMinute}`;
                }
                this.workflow.Scheduler.EndDate = this.schedulerData.EndDate;
                this.workflow.Scheduler.EndTime = this.schedulerData.EndTime;
                this.workflow.Scheduler.TimeZone = this.schedulerData.TimeZone;
            } else {
                this.workflow.Scheduler = null;
            }
            //workflow
            this.workflow.WorkflowId =
                firstHex32WorkflowId(this.workflowId, this.workflowData.WorkflowId) ||
                this.workflowData.WorkflowId;
            this.workflow.BusinessUnitParticipant =
                this.workflowData.BusinessUnitParticipant;
            this.workflow.sourceLocationPath = stringComparison(
                this.workflowData.TransferType,
                "pull"
            )
                ? resolvePullSourceLocationPathForSave(
                    this.workflow.WorkflowId,
                    this.workflowData.WorkflowName,
                )
                : resolvePushSourceLocationPathForSave(
                    this.workflowData.sourceLocationPath,
                    this.loadedSourceLocationSuffix,
                    this.workflow.WorkflowId,
                );
            this.workflow.TriggerFilePattern = stringComparison(
                this.workflowData.TransferType,
                "push"
            )
                ? this.filepattern.TriggerFilePattern
                : this.filepattern.TriggerFilePattern.map((element) =>
                    "\\".concat("/*", element.replace("/", "\\/"))
                );
            this.workflow.DataFilePattern = stringComparison(
                this.workflowData.TransferType,
                "push"
            )
                ? this.filepattern.DataFilePattern
                : this.filepattern.DataFilePattern.map((element) =>
                    "\\".concat("/*", element.replace("/", "\\/"))
                );
            this.workflow.TransferType = this.workflowData.TransferType;
            this.workflow.WorkflowName = this.workflowData.WorkflowName;
            this.workflow.workflowType = DEFAULT_WORKFLOW_TYPE_ODI;
            this.workflow.DeleteFiles = stringComparison(
                this.workflowData.TransferType,
                "pull"
            )
                ? true
                : this.workflowData.DeleteFiles == true
                    ? true
                    : false;

            if (
                stringComparisonCase(
                    this.loadedSourceLocationSuffix.toLowerCase(),
                    this.workflowData.sourceLocationPath.toLowerCase()
                )
            ) {
                await this.onEditWorkflow(this.workflow);
            } else {
                this.changeSourceLocation(
                    this.workflowId,
                    this.workflow.sourceLocationPath,
                    this.workflow
                );
            }
        }
    }

    async changeSourceLocation(oldWorkflowId, newSource, workflow) {
        const workData = await getRequest(
            Apis.GET_WORKFLOW + `/` + fixedEncodeURIComponent(oldWorkflowId)
        );
        const request = workData;
        const updateWorkflow = await deleteRequest(
            Apis.DELETE_WORKFLOW + `/` + fixedEncodeURIComponent(oldWorkflowId),
            workData.eTag
        );

        if (updateWorkflow?.status === 204) {
            workflow.status = workData.status;
            const response = await postRequest<WorkflowType>(
                Apis.ADD_WORKFLOW,
                workflow
            );
            if (response?.messageStatus === null) {
                this.apiLoading = false;
                this.toUpdate = this.toUpdate == "" ? "update" : "";
                showToastMessage("Workflow updated successfully.", "success");
                const router = new Router(routerConfig);
                router.go("/workflows");
            } else if (response.details.length > 0) {
                this.apiLoading = false;
                this.toUpdate = this.toUpdate == "" ? "update" : "";
                const errMsg = getWorkflowSaveErrorMessage(response.details);
                showToastMessage(errMsg, "danger");
            } else {
                this.apiLoading = false;
                this.toUpdate = this.toUpdate == "" ? "update" : "";
                showToastMessage("Something went wrong, please try again.", "danger");
            }
        } else if (updateWorkflow.details.length > 0) {
            this.apiLoading = false;
            this.toUpdate = this.toUpdate == "" ? "update" : "";
            const errMsg = getWorkflowSaveErrorMessage(updateWorkflow.details);
            showToastMessage(errMsg, "danger");
        } else {
            this.apiLoading = false;
            this.toUpdate = this.toUpdate == "" ? "update" : "";
            showToastMessage("Something went wrong, please try again.", "danger");
        }
    }

    async onEditWorkflow(workflow) {
        const workData = await getRequest(
            Apis.GET_WORKFLOW +
            `/` +
            fixedEncodeURIComponent(this.workflowId)
        );
        if (!workData || workData instanceof Response) {
            this.apiLoading = false;
            abortWorkflowLoad(workData);
            return;
        }
        workflow.status = workData.status;
            const updateWorkflow = await putRequest<WorkflowType>(
                Apis.UPDATE_WORKFLOW +
                `/` +
                fixedEncodeURIComponent(this.workflowId),
                workData.eTag,
                workflow
            );
            if (updateWorkflow?.messageStatus === null) {
                showToastMessage("Workflow details updated successfully.", "success");
                const router = new Router(routerConfig);
                router.go("/workflows");
            } else if (updateWorkflow.details.length > 0) {
                this.apiLoading = false;
                this.toUpdate = this.toUpdate == "" ? "update" : "";
                const errMsg = getWorkflowSaveErrorMessage(updateWorkflow.details);
                showToastMessage(errMsg, "danger");
            } else {
                this.apiLoading = false;
                this.toUpdate = this.toUpdate == "" ? "update" : "";
                showToastMessage("Something went wrong, please try again.", "danger");
            }
    }

    async connectedCallback() {
        this.apiLoading = true;
        this.activeTab = "";
        super.connectedCallback();
        try {
            const workData = await getRequest(
                Apis.GET_WORKFLOW + `/` + fixedEncodeURIComponent(this.workflowId)
            );
            if (!workData || workData instanceof Response) {
                abortWorkflowLoad(workData);
                return;
            }
            document.title = document.title.concat(" >", this.pageTitle);
        this.workflowData.WorkflowId = workData.workflowId ?? this.workflowId;
        this.workflowData.sourceLocationPath = extractSourceLocationSuffix(
            workData.sourceLocationPath
        );
        this.loadedSourceLocationSuffix = this.workflowData.sourceLocationPath;
        this.workflowData.loadedSourceLocationSuffix = this.workflowData.sourceLocationPath;
        this.workflowData.BusinessUnitParticipant =
            workData.businessUnitParticipant.toLowerCase();
        this.workflowData.TransferType = workData.transferType;
        this.workflowData.WorkflowName = workData.workflowName;
        this.isReadOnlyUser =
            this.isReadOnlyUser ||
            stringComparison(workData.status.toUpperCase(), "ACTIVE");
        this.pageTitle = this.isReadOnlyUser ? "View" : "Edit";
        this.workflowData.isEdit = true;
        syncGeneralInfoValid(this.workflowData);
        this.workflowData.DeleteFiles = workData.deleteFiles;
        this.notification = workData.notification;
        this.notification.forEach((element: any, index: Number) => {
            element.number = index + 1;
            element.added = true;
        });
        if (workData.scheduler != undefined) {
            this.schedulerData = workData.scheduler;
            this.oldSchedulerData = workData.scheduler;
            this.schedulerData.SchedulerName = workData.scheduler.schedulerName;
            this.schedulerData.Description = workData.scheduler.description;
            this.schedulerData.Expression = workData.scheduler.expression;
            this.schedulerData.StartDate = workData.scheduler.startDate;
            this.schedulerData.StartTime = workData.scheduler.startTime;
            if (this.schedulerData.StartTime) {
                const [hour, minute] = this.schedulerData.StartTime.split(":");
                this.schedulerData.StartHour = hour;
                this.schedulerData.StartMinute = minute;
            }
            this.schedulerData.EndDate = workData.scheduler.endDate;
            this.schedulerData.EndTime = workData.scheduler.endTime;
            this.schedulerData.TimeZone = workData.scheduler.timezone;
            this.schedulerData.valid = true;
            this.schedulerData.isEdit = true;
        }
        if (workData.workflowSteps.length > 0) {
            let workflowSteps = {
                FunctionName: "",
                StepName: "",
                DeleteSourceFile: false,
                FileMovePattern: [],
                DestinationFileInfo: {
                    Name: "",
                    Path: "",
                    LocationType: "",
                    StorageType: "",
                    FileRename: [],
                    BucketRename: "",
                    secretName: "",
                    secretValue: {},
                },
                SourceFileInfo: {
                    Name: "",
                    Path: "",
                    LocationType: "",
                    StorageType: "",
                    FileRename: [],
                    BucketRename: "",
                    secretName: "",
                    secretValue: {},
                },
                StepIndex: 0,
            };

            this.steps = [];
            // File-info source/destination leg rules: see workflow-file-info-leg.ts (canonical for templates).
            if (stringComparison(this.workflowData.TransferType, "PUSH")) {
                if (workData.workflowSteps[0].stepName == "rulechecker") {
                    workData.workflowSteps.splice(0, 1);
                    for (let i = 0; i < workData.workflowSteps.length; i++) {
                        workData.workflowSteps[i].stepIndex =
                            workData.workflowSteps[i].stepIndex - 1;
                    }
                }
                for (let i = 0; i < workData.workflowSteps.length; i++) {
                    this.steps.push(JSON.parse(JSON.stringify(workflowSteps)));
                    this.steps[i].stepName = workData.workflowSteps[i].stepName;
                    if (
                        stringComparison(
                            workData.workflowSteps[i].stepName,
                            "unprocessedfilearchive"
                        )
                    ) {
                        this.steps[i].functionName = workData.workflowSteps[i].stepName
                            .toString()
                            .toLowerCase();
                    } else {
                        this.steps[i].functionName = workData.workflowSteps[i].functionName;
                    }
                    this.steps[i].deleteSourceFile = stringComparison(
                        workData.workflowSteps[i].deleteSourceFile,
                        false
                    )
                        ? "false"
                        : "true";
                    this.steps[i].FileMovePattern =
                        workData.workflowSteps[i].fileMovePattern;
                    this.steps[i].stepIndex = workData.workflowSteps[i].stepIndex + 1;
                    this.steps[i].institutionUuid = readInstitutionUuidFromStep(
                        workData.workflowSteps[i]
                    );
                    if (stringComparison(this.steps[i].functionName, "filedelete")) {
                        this.steps[i].name = workData.workflowSteps[i].sourceFileInfo.name;
                        this.steps[i].path = workData.workflowSteps[i].sourceFileInfo.path;
                        this.sourceFolder = workData.workflowSteps[i].sourceFileInfo.name;
                        this.steps[i].locationType =
                            workData.workflowSteps[i].sourceFileInfo.locationType;
                        this.steps[i].storageType =
                            workData.workflowSteps[i].sourceFileInfo.storageType;
                        this.steps[i].fileRename =
                            workData.workflowSteps[i].sourceFileInfo.fileRename;
                        this.steps[i].bucketRename =
                            workData.workflowSteps[i].sourceFileInfo.bucketRename;
                        if (
                            this.steps[i].storageType == "azure" ||
                            this.steps[i].storageType == "amazons3remote"
                        ) {
                            this.steps[i].secretName =
                                workData.workflowSteps[i].destinationFileInfo.secretName;
                            this.steps[i].secretValue =
                                workData.workflowSteps[i].destinationFileInfo.secretValue;
                        } else {
                            this.steps[i].secretName =
                                workData.workflowSteps[i].sourceFileInfo.secretName;
                            this.steps[i].secretValue =
                                workData.workflowSteps[i].sourceFileInfo.secretValue;
                        }
                    } else {
                        this.steps[i].name =
                            workData.workflowSteps[i].destinationFileInfo.name;
                        this.steps[i].path =
                            workData.workflowSteps[i].destinationFileInfo.path;
                        this.steps[i].locationType =
                            workData.workflowSteps[i].destinationFileInfo.locationType;
                        this.steps[i].storageType =
                            workData.workflowSteps[i].destinationFileInfo.storageType;
                        this.steps[i].fileRename =
                            workData.workflowSteps[i].destinationFileInfo.fileRename;
                        this.steps[i].bucketRename =
                            workData.workflowSteps[i].destinationFileInfo.bucketRename;
                        if (
                            this.steps[i].storageType == "azure" ||
                            this.steps[i].storageType == "amazons3remote"
                        ) {
                            this.steps[i].secretName =
                                workData.workflowSteps[i].destinationFileInfo.secretName;
                            this.steps[i].secretValue =
                                workData.workflowSteps[i].destinationFileInfo.secretValue;
                        } else {
                            this.steps[i].secretName =
                                workData.workflowSteps[i].sourceFileInfo.secretName;
                            this.steps[i].secretValue =
                                workData.workflowSteps[i].sourceFileInfo.secretValue;
                        }
                    }
                    syncStepAuthTypesFromBothFileInfos(
                        this.steps[i],
                        workData.workflowSteps[i].sourceFileInfo,
                        workData.workflowSteps[i].destinationFileInfo
                    );
                    this.steps[i].path =
                        this.steps[i].path && !this.steps[i].path.startsWith("/")
                            ? "/" + this.steps[i].path
                            : this.steps[i].path;
                }
            } else if (stringComparison(this.workflowData.TransferType, "PULL")) {
                for (let i = 0; i < workData.workflowSteps.length; i++) {
                    this.steps.push(JSON.parse(JSON.stringify(workflowSteps)));
                    this.steps[i].stepName = workData.workflowSteps[i].stepName;
                    if (
                        stringComparison(
                            workData.workflowSteps[i].stepName,
                            "unprocessedfilearchive"
                        )
                    ) {
                        this.steps[i].functionName = workData.workflowSteps[i].stepName
                            .toString()
                            .toLowerCase();
                    } else {
                        this.steps[i].functionName = workData.workflowSteps[i].functionName;
                    }
                    this.steps[i].deleteSourceFile = stringComparison(
                        workData.workflowSteps[i].deleteSourceFile,
                        false
                    )
                        ? "false"
                        : "true";
                    this.steps[i].FileMovePattern =
                        workData.workflowSteps[i].fileMovePattern;
                    this.steps[i].stepIndex = workData.workflowSteps[i].stepIndex;
                    this.steps[i].institutionUuid = readInstitutionUuidFromStep(
                        workData.workflowSteps[i]
                    );
                    if (
                        stringComparison(this.steps[i].functionName, "filedownload") ||
                        stringComparison(this.steps[i].functionName, "filedelete")
                    ) {
                        this.steps[i].name = workData.workflowSteps[i].sourceFileInfo.name;
                        this.steps[i].path = workData.workflowSteps[i].sourceFileInfo.path;
                        this.sourceFolder = workData.workflowSteps[i].sourceFileInfo.name;
                        this.steps[i].locationType =
                            workData.workflowSteps[i].sourceFileInfo.locationType;
                        this.steps[i].storageType =
                            workData.workflowSteps[i].sourceFileInfo.storageType;
                        this.steps[i].fileRename =
                            workData.workflowSteps[i].sourceFileInfo.fileRename;
                        this.steps[i].bucketRename =
                            workData.workflowSteps[i].sourceFileInfo.bucketRename;

                        this.steps[i].secretName =
                            workData.workflowSteps[i].sourceFileInfo.secretName;
                        this.steps[i].secretValue =
                            workData.workflowSteps[i].sourceFileInfo.secretValue;
                    } else {
                        this.steps[i].name =
                            workData.workflowSteps[i].destinationFileInfo.name;
                        this.steps[i].path =
                            workData.workflowSteps[i].destinationFileInfo.path;
                        this.steps[i].locationType =
                            workData.workflowSteps[i].destinationFileInfo.locationType;
                        this.steps[i].storageType =
                            workData.workflowSteps[i].destinationFileInfo.storageType;
                        this.steps[i].fileRename =
                            workData.workflowSteps[i].destinationFileInfo.fileRename;
                        this.steps[i].bucketRename =
                            workData.workflowSteps[i].destinationFileInfo.bucketRename;
                        if (
                            this.steps[i].storageType == "azure" ||
                            this.steps[i].storageType == "amazons3remote"
                        ) {
                            this.steps[i].secretName =
                                workData.workflowSteps[i].destinationFileInfo.secretName;
                            this.steps[i].secretValue =
                                workData.workflowSteps[i].destinationFileInfo.secretValue;
                        } else {
                            this.steps[i].secretName =
                                workData.workflowSteps[i].sourceFileInfo.secretName;
                            this.steps[i].secretValue =
                                workData.workflowSteps[i].sourceFileInfo.secretValue;
                        }
                    }
                    syncStepAuthTypesFromBothFileInfos(
                        this.steps[i],
                        workData.workflowSteps[i].sourceFileInfo,
                        workData.workflowSteps[i].destinationFileInfo
                    );
                    this.steps[i].path =
                        this.steps[i].path && !this.steps[i].path.startsWith("/")
                            ? "/" + this.steps[i].path
                            : this.steps[i].path;
                }
            }
        } else {
            this.steps = [];
        }
        let regexPattern = "\\/*";
        this.filepattern.DataFilePattern = stringComparison(
            workData.transferType,
            "push"
        )
            ? workData.dataFilePattern
            : workData.dataFilePattern.map((element) =>
                element.replace(regexPattern, "").replace("\\/", "/")
            );
        this.filepattern.TriggerFilePattern = stringComparison(
            workData.transferType,
            "push"
        )
            ? workData.triggerFilePattern
            : workData.triggerFilePattern.map((element) =>
                element.replace(regexPattern, "").replace("\\/", "/")
            );
        this.activeTab = "page1";
        // Form is interactive once the spinner clears. Capture before General Info
        // lookups; fold the BU auto-fill after — do not recapture live form state.
        this._cancelBaseline = captureWorkflowCancelBaseline(this.cancelSnapshotInput());
        this.apiLoading = false;
        await this.updateComplete;
        await afterGeneralInfoLoad(this);
        this.foldGeneralInfoDefaults();
        } finally {
            this.apiLoading = false;
        }
    }

    private cancelSnapshotInput() {
        return {
            workflowData: this.workflowData,
            filepattern: this.filepattern,
            notification: this.notification,
            steps: this.steps,
            schedulerData: this.schedulerData,
        };
    }

    /**
     * Fold the Business Admin BU auto-fill once GI lookups have landed.
     * Call from Cancel as well as after load — do not recapture live form state.
     * Edit does not auto-fill (`isEdit`); this still avoids folding a user-typed BU.
     */
    private foldGeneralInfoDefaults() {
        if (this._giDefaultsFolded) return;
        const gi = this.shadowRoot?.querySelector("workflow-general-info") as
            | {
                lookupsDone?: boolean;
                autoFilledBusinessUnitParticipant?: string;
            }
            | null
            | undefined;
        const { lookupsDone, autoFilled: filled } = resolveGeneralInfoAutoFill(this.workflowData, gi);
        if (!lookupsDone) return;
        this._giDefaultsFolded = true;
        if (filled !== undefined) {
            this._cancelBaseline = applyWorkflowCancelBaselineDefaults(this._cancelBaseline, {
                workflowData: { BusinessUnitParticipant: filled },
            });
        }
    }

    /** ACME-1050: true only after real user edits vs hydrate baseline. */
    private hasUnsavedChanges(): boolean {
        this.foldGeneralInfoDefaults();
        return isWorkflowCancelDirty(this._cancelBaseline, this.cancelSnapshotInput());
    }

    onBackClick() {
        const router = new Router(routerConfig);
        router.go("/workflows");
    }

    async onCancelClick() {
        if (this.isReadOnlyUser) {
            AppRouters.go("/workflows");
            return;
        }
        // No change → no prompt (ACME-1050). Do not remove this gate.
        if (!this.hasUnsavedChanges()) {
            AppRouters.go("/workflows");
            return;
        }
        const result = await openJhftDialog({
            variant: "warning",
            title: "Unsaved Changes",
            message: "You have unsaved changes. Are you sure you want to leave without saving?",
            cancelLabel: "Stay",
            confirmLabel: "Leave Without Saving",
        });
        if (result === "confirm") {
            AppRouters.go("/workflows");
        }
    }

    onSaveWorkflowPatternsEvent(e) {
        this.isFilePatternValid =
            e?.detail?.DataFilePattern.length > 0 &&
            e?.detail?.TriggerFilePattern.length > 0;
    }

    render() {
        return html`
    ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
    <div id="editWorkflowTab">
        <h1>
            <span>${this.pageTitle} ${this.workflowData.WorkflowName}</span>
        </h1>
        <jha-card>
            <jha-tab bordered>
                <jha-tab-item data-auto-id="generalInfoTab" ?active=${stringComparison(this.activeTab, "page1")}
                    @click=${() => {
                this.activeTab = "page1";
                this.workFlowDisable = false;
            }}
                    >
                    General Information
                    ${isGeneralInfoTabComplete(this.workflowData)
                ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
                : html`
                    <jha-icon-warning-filled icon></jha-icon-warning-filled>
                    `}
                </jha-tab-item>
                <jha-tab-item data-auto-id="filePatternTab" ?active=${stringComparison(this.activeTab, "page2")}
                    @click=${() => {
                this.activeTab = "page2";
                this.workFlowDisable = false;
            }}
                    >
                    File Patterns
                    ${this.isFilePatternValid
                ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
                : html`
                    <jha-icon-warning-filled icon></jha-icon-warning-filled>
                    `}
                </jha-tab-item>
                <jha-tab-item data-auto-id="notificationTab" ?active=${stringComparison(this.activeTab, "page3")}
                    @click=${() => {
                this.activeTab = "page3";
                this.workFlowDisable = false;
            }}
                    >
                    Notifications
                </jha-tab-item>
                <jha-tab-item data-auto-id="workflowStepsTab" ?active=${stringComparison(this.activeTab, "page4")}
                    @click=${() => {
                this.activeTab = "page4";
                this.workFlowDisable = false;
            }}
                    >
                    Workflow Steps
                </jha-tab-item>
                ${stringComparison(this.workflowData.TransferType, "PULL")
                ? html` <jha-tab-item data-auto-id="schedulerTab" ?active=${stringComparison(this.activeTab, "page5")}
                    @click=${() => {
                        this.activeTab = "page5";
                        this.workFlowDisable = false;
                    }}
                    >
                    Scheduler${this.isSchedulerValid
                        ? html` <jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
                        : html`
                    <jha-icon-warning-filled icon></jha-icon-warning-filled>
                    `}
                </jha-tab-item>`
                : undefined}
            </jha-tab>
            <div id="tabContent">
                ${stringComparison(this.activeTab, "page1")
                ? html`<workflow-general-info @onWorkflowNameChange=${this.onSaveWorkflowCustomEvent}
                    .formData=${this.workflowData} .isReadOnlyUser=${this.isReadOnlyUser}>
                </workflow-general-info>`
                : undefined}
                ${stringComparison(this.activeTab, "page2")
                ? html`<file-pattern-view @onFilePatternChange=${this.onSaveWorkflowPatternsEvent}
                    .formData=${this.filepattern} .isReadOnlyUser=${this.isReadOnlyUser}>
                </file-pattern-view>`
                : undefined}
                ${stringComparison(this.activeTab, "page3")
                ? html`<notification-view @onformNotValid=${this.unsavednotificationChanges}
                    .formData=${this.notificationData} @onNotificationChange=${this.onSaveNotificationCustomEvent}
                    .notificationList=${this.notification} .isReadOnlyUser=${this.isReadOnlyUser}>
                </notification-view>`
                : undefined}
                ${stringComparison(this.activeTab, "page4")
                ? html`<workflow-steps-view @onStepsChange=${this.onSaveStepsCustomEvent} .formData=${this.workflowData}
                    .workflowStepsData=${this.steps} .isReadOnlyUser=${this.isReadOnlyUser}>
                </workflow-steps-view>`
                : undefined}
                ${stringComparison(this.activeTab, "page5") &&
                stringComparison(this.workflowData.TransferType, "PULL")
                ? html` <p>
                    <scheduler-view @onSchedulerChange=${this.onSaveSchedulerEvent} .formData=${this.schedulerData}
                        .isReadOnlyUser=${this.isReadOnlyUser}></scheduler-view>
                </p>`
                : undefined}
            </div>
            <div id="actionBtns" style="margin-top:5%;">
                ${!this.isReadOnlyUser
                ? html`
                <jha-tooltip top text="Click to save the workflow details.">
                    <jha-button data-auto-id="saveBtn" @click=${this.onSaveWorkflowClick} sync
                        ?disabled=${!this.hasUnsavedChanges()}>
                        Save Workflow
                    </jha-button>
                </jha-tooltip>
                `
                : undefined}
                <jha-tooltip top text="Click to cancels and exit back to the workflows page.">
                    <jha-button data-auto-id="cancelBtn" tertiary sync @click=${this.onCancelClick}>
                        Cancel
                    </jha-button>
                </jha-tooltip>
            </div>
        </jha-card>
    </div>
    `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "edit-workflow-tab-view": EditWorkflowTabView;
    }
}
